<template>
  <div class="notification-layout">
    <div class="notification-layout-main">
      <div class="notification-layout__icon">
        <slot name="icon"> </slot>
      </div>

      <div class="notification-layout__content">
        <slot name="content"> </slot>
      </div>
    </div>

    <footer v-if="$slots.footer" class="notification-layout__footer">
      <slot name="footer"> </slot>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'NotificationLayout'
};
</script>
<style scoped lang="scss">
.notification-layout {
  &-main {
      display: flex;
  }

  &__icon {
      width: 70px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 14px;
      flex-shrink: 0;
  }

  &__content {
      padding: 15px 20px 15px 0;
      flex-grow: 1;
  }
}
</style>
